import { updateDataAction, fetchFormSuccessAction } from '../actions/form';
import { createReducer } from 'redux-create-reducer';

const dirtyReducer = createReducer(false, {
  [updateDataAction]: (state, action) => true,
  [fetchFormSuccessAction]: (state, action) => false,
});

export default dirtyReducer;

export const getIsDirty = state => state.dirty;



// WEBPACK FOOTER //
// ./src/modules/saas/aast/case-study/reducers/dirty.js